// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__28pkY","row":"styles_row__1f0tm","col":"styles_col__246s2"};